import {
  UNSOLVE,
  TOGGLE_MUTE,
  FETCH_ALL_JOKES_SUCCESS,
  FETCH_ALL_JOKES_FAILURE,
  NEXT_JOKE,
  LOAD_JOKE_BY_ID,
  RESTART_JOKE
} from "../actions/jokeActions";
import {
  WORD_PLACED_SUCCESS,
  WORD_PLACED_FAILURE,
  ALL_WORDS_PLACED
} from "../actions/wordActions";

export function fisherYatesShuffle(array) {
  const result = array.slice();
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

// Shuffles, then guarantees no word lands at the palette index matching
// its own answer position - avoids the shuffle accidentally giving a hint.
export function shuffleWords(words) {
  if (words.length <= 1) {
    return words.slice();
  }
  let shuffled = fisherYatesShuffle(words);
  let attempts = 0;
  while (shuffled.some((word, index) => word.order === index) && attempts < 100) {
    shuffled = fisherYatesShuffle(words);
    attempts++;
  }
  return shuffled;
}

// the fresh (re-scrambled, nothing placed yet) state for presenting a
// given joke - shared by NEXT_JOKE, LOAD_JOKE_BY_ID, and RESTART_JOKE,
// which differ only in how they pick/remove from the jokes queue
function fresh_joke_state(joke) {
  const punchline_words = joke.words
  return {
    punchline_words: punchline_words,
    shuffled_words: shuffleWords(punchline_words),
    words_correct: Array(punchline_words.length).fill(false),
    setup: joke.setup,
    image: joke.image,
  }
}

const initialState = {
  jokes: [],
  words_correct: [],
  setup: "",
  image: "",
  punchline_words: [],
  shuffled_words: [],
  error: null,
  solved: 'hidden',
  mute: false,
  out_of_jokes:false,
  // the last thing worth announcing to a screen reader (see #game_live_region
  // in Layout.jsx) - not reset between actions, since an aria-live region
  // only needs to change value to re-announce, it doesn't need clearing
  announcement: '',
};

export default function jokeReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case FETCH_ALL_JOKES_SUCCESS:
      // the backend already orders this list (unseen-for-this-player
      // first, then by avg-solve-time * completion-rate ascending) - just
      // consume it front-to-back
      return Object.assign({}, state, {jokes: action.payload.all_jokes['all_jokes'],out_of_jokes:false})
    case NEXT_JOKE: {
      if (!state.jokes.length) {
        return Object.assign({}, state, { out_of_jokes: true })
      }
      const [joke, ...rest] = state.jokes
      return Object.assign({}, state, { jokes: rest }, fresh_joke_state(joke))
    }
    case LOAD_JOKE_BY_ID: {
      const target_id = action.payload.joke_id
      const found_index = state.jokes.findIndex(joke => joke.id === target_id)
      if (found_index === -1) {
        // requested joke isn't available (bad url, filtered out, or
        // already played this session and popped off its queue) - fall
        // back to whatever's next in line rather than a dead page
        return jokeReducer(state, { type: NEXT_JOKE })
      }
      const joke = state.jokes[found_index]
      const new_jokes = state.jokes.slice(0, found_index).concat(state.jokes.slice(found_index + 1))
      return Object.assign({}, state, { jokes: new_jokes }, fresh_joke_state(joke))
    }
    case RESTART_JOKE: {
      // unlike NEXT_JOKE/LOAD_JOKE_BY_ID, this joke isn't necessarily (and
      // after a solve, never is) in the queue - leave it untouched
      return Object.assign({}, state, fresh_joke_state(action.payload.joke))
    }
    case FETCH_ALL_JOKES_FAILURE:
      return Object.assign({}, state, {error: action.payload,jokes: []})
    case TOGGLE_MUTE:
      const mute_state = state.mute
      return Object.assign({}, state, {mute: !mute_state})
    case WORD_PLACED_SUCCESS:
      const new_words_correct = state.words_correct.slice();
      new_words_correct[action.payload.order] = true;
      const placed_word = state.punchline_words[action.payload.order];
      return Object.assign({}, state, {
        words_correct: new_words_correct,
        announcement: 'Correct' + (placed_word ? ': "' + placed_word.word + '" placed.' : '.'),
      })
    case WORD_PLACED_FAILURE:
      const words_incorrect = state.words_correct.slice();
      words_incorrect[action.payload.order] = false;
      return Object.assign({}, state, {words_correct:words_incorrect, announcement: 'Not quite - try again.'})
    case ALL_WORDS_PLACED: {
      const words_correct = state.words_correct.slice();
      for(let i=0; i<words_correct.length; i++){
        if (words_correct[i] == false){
          return Object.assign({}, state, {solved:'hidden'})
        }
      }
      if (state.solved === 'visible'){
        return state;
      }
      return Object.assign({}, state, {solved:'visible', announcement: 'Joke solved!'})
    }
    case UNSOLVE:
      return Object.assign({}, state, {solved:'hidden'})
    default:
      return state;
  }
}
